import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "avatar-wrapper" }
const _hoisted_3 = { class: "avatar-image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "name-label" }
const _hoisted_6 = {
  class: "state-label",
  "data-qe-id": "matching-state"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "avatar-image" }
const _hoisted_9 = {
  class: "state-label",
  "data-qe-id": "matching-state"
}
const _hoisted_10 = { class: "progressinfo-pending" }
const _hoisted_11 = { class: "progressinfo-finished" }
const _hoisted_12 = {
  key: 0,
  class: "tick icf-ok"
}

import { computed } from 'vue'
import { MatchingProgress } from '@/model/Matching'
import CGenericAvatar from '@/components/CGenericAvatar.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CMatchingSlot',
  props: {
    userAvatarUrl: {},
    name: {},
    state: { default: MatchingProgress.LOADING }
  },
  setup(__props: any) {

const props = __props

const stateClass = computed(() => {
  switch (props.state) {
    case MatchingProgress.LOADING:
      return 'loading'
    case MatchingProgress.SUCCESS:
      return 'success'
    case MatchingProgress.FAILED:
      return 'failed'
    default:
      return ''
  }
})

return (_ctx: any,_cache: any) => {
  const _component_t_card = _resolveComponent("t-card")!

  return (_openBlock(), _createBlock(_component_t_card, {
    class: _normalizeClass(['matching-slot', stateClass.value]),
    "data-qe-id": "matching-slot"
  }, {
    default: _withCtx(() => [
      (_ctx.name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.userAvatarUrl + 'PROFILE_185.png'
                }, null, 8, _hoisted_4)
              ])
            ]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.name), 1),
            _createElementVNode("p", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('matchingView.searchState.found')), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["avatar-wrapper small", stateClass.value])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(CGenericAvatar, { state: _ctx.state }, null, 8, ["state"])
              ])
            ], 2),
            _createElementVNode("p", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('matchingView.searchState.searching')), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('matchingView.searchState.found')), 1)
            ]),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (_ctx.state === _unref(MatchingProgress).SUCCESS)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})